import { get } from 'lodash'

import {
  GET_CONTACT_MATCH_REQUEST,
  GET_CONTACT_MATCH_SUCCESS,
  CONTACT_MATCH_PUSHER_MESSAGE,
  GET_CONTACT_MATCH_FAILURE
} from '../../actions'

const initial = {
  isLoading: true,
  totalContacts: 0,
  validContacts: 0,
  requestDate: null,
  percentComplete: 0,
  data: []
}

/**
 * Contact Matches Reducer
 * @param state
 * @param action
 * @returns {[securityId]: [{matches}]}
 */
const matches = (state = initial, action) => {
  const { payload } = action
  const companyId = get(payload, 'meta.companyId') || get(payload, 'request.companyId')

  switch (action.type) {
    case GET_CONTACT_MATCH_REQUEST:
      const reqCompanyId = action.req && action.req.securityId
      return {
        ...state,
        [reqCompanyId]: {
          ...initial,
          requestDate: new Date()
        }
      }

    case GET_CONTACT_MATCH_SUCCESS:
      return {
        ...state,
        [companyId]: {
          ...state[companyId],
          isLoading: true,
          totalContacts: get(payload, 'meta.totalContacts'),
          validContacts: get(payload, 'meta.validContacts'),
          requestDate: new Date(),
          data: []
        }
      }

    case GET_CONTACT_MATCH_FAILURE:
      return {
        ...state,
        [companyId]: {
          isLoading: false,
          totalContacts: 0,
          validContacts: 0,
          requestDate: null,
          data: []
        }
      }

    // Pusher responses
    case CONTACT_MATCH_PUSHER_MESSAGE:
      const prevCompanyState = state[companyId]
      const data = get(prevCompanyState, 'data', [])
        .filter((match) => get(match, 'request.contact_id') !== get(payload, 'request.contact_id'))
        .concat([{
          ...payload,
          result: payload.result && {
            ...payload.result,
            _id: get(payload, 'result._id.$oid')
          }
        }])

      const validContacts = get(prevCompanyState, 'validContacts', 0)
      const isLoading = validContacts !== data.length
      const percentComplete = validContacts
        ? Math.round((data.length / validContacts) * 100)
        : 0

      return {
        ...state,
        [companyId]: {
          ...prevCompanyState,
          isLoading,
          percentComplete,
          data
        }
      }

    default:
      return state
  }
}

export default matches
